<ng-container *transloco="let t">
<!-- Shortcuts toggle -->
<button mat-icon-button (click)="openPanel()" #shortcutsOrigin>
    <mat-icon [svgIcon]="'heroicons_outline:squares-plus'"></mat-icon>
</button>

<!-- Shortcuts panel -->
<ng-template #shortcutsPanel>
    <div
        class="fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:w-90 sm:min-w-90 sm:rounded-2xl"
        [ngClass]="{ 'sm:w-140 sm:min-w-140': mode === 'pick-icon' }"
    >
        <!-- Header -->
        <div
            class="flex shrink-0 items-center bg-primary py-4 pl-6 pr-4 text-on-primary"
        >
            <div class="-ml-1 mr-3 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon
                        class="text-current icon-size-5"
                        [svgIcon]="'heroicons_solid:x-mark'"
                    ></mat-icon>
                </button>
            </div>
            <div class="flex items-center text-lg font-medium leading-10">
                <span>{{ t('shortcuts.title') }}</span>
                @if (mode === 'add') {
                    <span class="ml-1">{{ t('shortcuts.addNew') }}</span>
                }
                @if (mode === 'modify' || mode === 'edit') {
                    <span class="ml-1">{{ t('shortcuts.editing') }}</span>
                }
                @if (mode === 'pick-icon') {
                    <span class="ml-1">{{ t('shortcuts.chooseIcon') }}</span>
                }
            </div>
            <div class="ml-auto">
                <!-- View mode -->
                @if (mode === 'view') {
                    <button
                        mat-icon-button
                        (click)="changeMode('modify')"
                        [matTooltip]="t('shortcuts.enterEditMode')"
                    >
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="'heroicons_solid:pencil-square'"
                        ></mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        (click)="newShortcut()"
                        [matTooltip]="t('shortcuts.addShortcut')"
                    >
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="'heroicons_solid:plus-circle'"
                        ></mat-icon>
                    </button>
                }
                @if (mode === 'modify') {
                    <button
                        mat-icon-button
                        (click)="changeMode('view')"
                        [matTooltip]="t('shortcuts.exitEditMode')"
                    >
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    </button>
                }
                @if (mode === 'add') {
                    <button
                        mat-icon-button
                        (click)="changeMode('view')"
                        [matTooltip]="t('common.cancel')"
                    >
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="'heroicons_solid:x-circle'"
                        ></mat-icon>
                    </button>
                }
                @if (mode === 'edit') {
                    <button
                        mat-icon-button
                        (click)="changeMode('modify')"
                        [matTooltip]="t('common.cancel')"
                    >
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="'heroicons_solid:x-circle'"
                        ></mat-icon>
                    </button>
                }
                @if (mode === 'pick-icon') {
                    <button
                        mat-icon-button
                        (click)="cancelIconPicker()"
                        [matTooltip]="t('shortcuts.backToForm')"
                    >
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="'heroicons_solid:arrow-left'"
                        ></mat-icon>
                    </button>
                }
            </div>
        </div>

        <div
            class="bg-card relative -mb-px flex flex-auto flex-col overflow-y-auto sm:max-h-120"
            [ngClass]="{ 'sm:max-h-160': mode === 'pick-icon' }"
        >
            <!-- View / Modify mode -->
            @if (mode === 'view' || mode === 'modify') {
                <div class="grid grid-flow-row grid-cols-2">
                    @for (
                        shortcut of shortcuts;
                        track trackByFn($index, shortcut)
                    ) {
                        <div
                            class="group bg-card relative flex flex-col overflow-hidden border-b border-r even:border-r-0 hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                        >
                            @if (mode === 'modify') {
                                <div
                                    class="absolute inset-0 z-99 cursor-pointer"
                                    (click)="editShortcut(shortcut)"
                                ></div>
                            }
                            @if (!shortcut.useRouter) {
                                <a
                                    class="flex h-full w-full flex-col items-center justify-center py-6 no-underline"
                                    [ngClass]="{ 'pointer-events-none': mode === 'modify' }"
                                    [href]="shortcut.link"
                                >
                                    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                                </a>
                            }
                            @if (shortcut.useRouter) {
                                <a
                                    class="flex h-full w-full flex-col items-center justify-center py-6 no-underline"
                                    [ngClass]="{ 'pointer-events-none': mode === 'modify' }"
                                    [routerLink]="shortcut.link"
                                >
                                    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                                </a>
                            }
                            <ng-template #linkContent>
                                <div
                                    class="relative mb-3 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700"
                                >
                                    @if (mode === 'modify') {
                                        <mat-icon
                                            class="absolute z-20 opacity-0 icon-size-5 group-hover:opacity-100"
                                            [svgIcon]="'heroicons_solid:pencil'"
                                        ></mat-icon>
                                    }
                                    <mat-icon
                                        class="z-10"
                                        [ngClass]="{ 'group-hover:opacity-0': mode === 'modify' }"
                                        [svgIcon]="shortcut.icon"
                                    ></mat-icon>
                                </div>
                                <div class="text-center font-medium">{{ shortcut.label }}</div>
                                <div class="text-secondary text-center text-md">{{ shortcut.description }}</div>
                            </ng-template>
                        </div>
                    }
                </div>

                @if (!shortcuts || !shortcuts.length) {
                    <div class="flex flex-auto flex-col items-center justify-center px-8 py-12 sm:justify-start">
                        <div class="flex h-14 w-14 flex-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-600">
                            <mat-icon
                                class="text-primary-700 dark:text-primary-50"
                                [svgIcon]="'heroicons_outline:bookmark'"
                            ></mat-icon>
                        </div>
                        <div class="mt-5 text-2xl font-semibold tracking-tight">{{ t('shortcuts.noShortcuts') }}</div>
                        <div class="text-secondary mt-1 w-full max-w-60 text-center text-md">
                            {{ t('shortcuts.emptyMessage') }}
                        </div>
                    </div>
                }
            }

            <!-- Add/Edit mode -->
            @if (mode === 'add' || mode === 'edit') {
                <form class="p-6" [formGroup]="shortcutForm">
                    <mat-form-field class="w-full">
                        <mat-label>{{ t('shortcuts.labelField') }}</mat-label>
                        <input matInput [formControlName]="'label'" required />
                    </mat-form-field>
                    <mat-form-field class="w-full">
                        <mat-label>{{ t('shortcuts.descriptionField') }}</mat-label>
                        <input matInput [formControlName]="'description'" />
                    </mat-form-field>

                    <!-- Icon selector button -->
                    <div class="mb-4">
                        <div class="text-secondary mb-2 text-sm font-medium">{{ t('shortcuts.iconSection') }}</div>
                        <button
                            type="button"
                            class="flex w-full items-center rounded-lg border border-gray-300 px-4 py-3 text-left transition hover:border-primary dark:border-gray-600 dark:hover:border-primary"
                            (click)="openIconPicker()"
                        >
                            @if (shortcutForm.get('icon')?.value) {
                                <mat-icon
                                    class="mr-3 icon-size-6"
                                    [svgIcon]="shortcutForm.get('icon')!.value"
                                ></mat-icon>
                                <span class="text-sm">{{ shortcutForm.get('icon')!.value }}</span>
                            } @else {
                                <mat-icon class="text-hint mr-3 icon-size-6" [svgIcon]="'heroicons_outline:squares-2x2'"></mat-icon>
                                <span class="text-hint text-sm">{{ t('shortcuts.chooseAnIcon') }}</span>
                            }
                            <mat-icon
                                class="text-hint ml-auto icon-size-4"
                                [svgIcon]="'heroicons_solid:chevron-right'"
                            ></mat-icon>
                        </button>
                    </div>

                    <mat-form-field class="w-full">
                        <mat-label>{{ t('shortcuts.linkField') }}</mat-label>
                        <input matInput [formControlName]="'link'" required />
                    </mat-form-field>
                    <mat-slide-toggle [color]="'primary'" [formControlName]="'useRouter'">
                        {{ t('shortcuts.useRouter') }}
                    </mat-slide-toggle>
                    <div class="mt-4 flex items-center justify-end">
                        @if (mode === 'edit') {
                            <button class="mr-2" mat-flat-button type="button" (click)="delete()">
                                {{ t('common.delete') }}
                            </button>
                        }
                        <button
                            mat-flat-button
                            [color]="'primary'"
                            [disabled]="!shortcutForm.valid"
                            type="button"
                            (click)="save()"
                        >
                            @if (mode === 'add') { {{ t('common.add') }} }
                            @if (mode === 'edit') { {{ t('common.update') }} }
                        </button>
                    </div>
                </form>
            }

            <!-- Icon picker mode -->
            @if (mode === 'pick-icon') {
                <div class="flex flex-col">
                    <!-- Category tabs -->
                    <div class="flex gap-1 overflow-x-auto border-b px-3 py-2">
                        @for (cat of iconCategories; track cat.namespace) {
                            <button
                                type="button"
                                class="shrink-0 rounded-full px-3 py-1.5 text-xs font-medium transition"
                                [ngClass]="{
                                    'bg-primary text-on-primary': activeCategory === cat,
                                    'text-secondary hover:bg-gray-100 dark:hover:bg-gray-800': activeCategory !== cat
                                }"
                                (click)="setIconCategory(cat)"
                            >
                                {{ cat.label }}
                            </button>
                        }
                    </div>

                    <!-- Search -->
                    <div class="border-b px-3 py-2">
                        <div class="relative">
                            <mat-icon
                                class="text-hint absolute left-3 top-1/2 -translate-y-1/2 icon-size-4"
                                [svgIcon]="'heroicons_outline:magnifying-glass'"
                            ></mat-icon>
                            <input
                                class="w-full rounded-lg border border-gray-300 bg-transparent py-2 pl-10 pr-3 text-sm placeholder-gray-400 focus:border-primary focus:outline-none dark:border-gray-600"
                                placeholder="Search {{ activeCategory.label }} icons..."
                                [(ngModel)]="iconSearch"
                                [ngModelOptions]="{ standalone: true }"
                            />
                        </div>
                        <div class="text-hint mt-1 text-xs">
                            {{ totalMatchCount }} icons
                            @if (totalMatchCount > 200) {
                                (showing first 200 — use search to narrow)
                            }
                        </div>
                    </div>

                    <!-- Icon grid -->
                    <div class="grid grid-cols-6 gap-0 overflow-y-auto p-1 sm:grid-cols-7">
                        @for (iconName of displayedIcons; track iconName) {
                            <button
                                type="button"
                                class="flex flex-col items-center justify-center rounded-lg p-2 transition hover:bg-primary hover:bg-opacity-10"
                                [ngClass]="{
                                    'bg-primary bg-opacity-15 ring-1 ring-primary':
                                        shortcutForm.get('icon')?.value === activeCategory.namespace + ':' + iconName
                                }"
                                [matTooltip]="iconName"
                                (click)="selectIcon(iconName)"
                            >
                                <mat-icon
                                    class="icon-size-6"
                                    [svgIcon]="activeCategory.namespace + ':' + iconName"
                                ></mat-icon>
                                <span class="mt-1 max-w-full truncate text-center text-[10px] leading-tight text-gray-500">
                                    {{ iconName }}
                                </span>
                            </button>
                        }
                    </div>

                    @if (displayedIcons.length === 0) {
                        <div class="text-hint flex flex-col items-center py-12 text-sm">
                            <mat-icon class="mb-2 icon-size-8" [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                            {{ t('search.noResults') }}
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</ng-template>
</ng-container>
